import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "../../../../Components/UI/Button/Button";
import Card from "../../../../Components/UI/Card/Card";
// import Helper from "../../../lib/Helper";

import PhotoReader from "./PhotoReader";

import { imageActions } from "../../store/image";


const Photo = ({ onValidChange, ...props }) => {
  const dispatch = useDispatch();

  const [image, setImage] = useState(null);
  const [canceled, setCanceled] = useState(false);

  useEffect(() => { onValidChange(!!image); }, [image]);

  const photoTakenHandler = async (img) => {
    dispatch( imageActions.store(img) );
    setImage( img );
    setCanceled( false );
  };

  const cancelHandler = () => {
    setImage( null );
    setCanceled( true );
  };

  return (
    <>
      {
        image
        ? <>
            <Card>
              <img src={image} width="100px" />
            </Card>
            <br />
            <Button onClick={() => { setImage(null); setCanceled(false); }}>Neues Foto</Button>
          </>
        : canceled
          ? <Button onClick={() => setCanceled(false)}>Foto aufnehmen</Button>
          : <PhotoReader
              onCancel={cancelHandler}
              onTrigger={photoTakenHandler}
            />
      }
    </>
  );
};

export default Photo;

